<template>
  <div
    id="modal_showApp"
    class="modal fade"
  >
    <div
      id="print-area"
      class="modal-dialog modal-full"
      style="max-width: 850px"
    >
      <div
        class="modal-content"
        style="border-style: dashed; border-width: 1px"
      >
        <div class="modal-header">
          <button
            id="close-button"
            type="button"
            class="close"
            @click="closeModal('modal_showApp')"
          >
            &times;
          </button>
        </div>
        <table
          style="width: 100%"
          id="head-table"
        >
          <tr>
            <td class="print-pl-20">
              <img
                style="width: 110px; height: 100px"
                id="header-img"
                src="../../../assets/images/black_shipzone.png"
                alt=""
              />
            </td>
            <td>
              <table
                id="company-info"
                style="width: 100%;" class="print-ml-0"
              >
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-20">
                    {{ companyData.company_name }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-20">
                    {{ companyData.company_address }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-20">
                    {{ companyData.company_email }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-20">
                    {{ companyData.phone_number }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <div class="modal-body">
          <table
            style="width: 100%"
            id="print-table1"
          >
            <tr>
              <td id="credit-table-header">
                <strong style="font-size: 20px">
                  <span v-if="detailData.action === 'cash back'">{{ $t('logs.cashBackInvoiceTitle') }}</span>
                  <span v-else>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ $t('logs.receiptLabel') }}
                  </span>
                </strong>
              </td>
            </tr>
          </table>

          <table
            style="width: 100%"
            id="print-table2"
          >
            <tr>
              <td id="info-section1">
                <!-- <p style="font-size: 14px; font-weight: bold; margin: 8px 0px">
                  Branch:
                  <span style="font-weight: normal">{{ detailData.branch_name }}</span>
                </p> -->
                <p style="font-size: 14px; font-weight: bold; margin: 8px 0px">
                  {{ $t('columns.invoiceNumber') }}:
                  <span style="font-weight: normal">{{ detailData.invoice_number }}</span>
                </p>
                <p
                  v-if="detailData.base_invoice_number != null"
                  style="font-size: 14px; font-weight: bold; margin: 8px 0px"
                >
                  {{ $t('logs.creditInvoiceNumber') }}:
                  <span style="font-weight: normal">{{ detailData.base_invoice_number }}</span>
                </p>
                <p
                  v-if="detailData.credit_log_action_date != null"
                  style="font-size: 14px; font-weight: bold; margin: 8px 0px"
                >
                  {{ $t('customer.invoiceDate') }}:
                  <span style="font-weight: normal">{{ detailData.credit_log_action_date }}</span>
                </p>
                <p
                  v-else
                  style="font-size: 14px; font-weight: bold; margin: 8px 0px"
                >
                  {{ $t('customer.invoiceDate') }}:
                  <span style="font-weight: normal">{{ detailData.created_at }}</span>
                </p>
              </td>
              <td id="info-section2">
                <p style="font-size: 14px; font-weight: bold; margin: 8px 0px">
                  {{ $t('columns.customerName') }}:
                  <span style="font-weight: normal">{{ detailData.customer_name }}</span>
                </p>
                <p style="font-size: 14px; font-weight: bold; margin: 8px 0px">
                  {{ $t('logs.customerAddress') }}:
                  <span style="font-weight: normal">{{ detailData.customer_address }}</span>
                </p>
                <p style="font-size: 14px; font-weight: bold; margin: 8px 0px">
                  {{ $t('logs.customerTel') }}:
                  <span style="font-weight: normal">{{ detailData.phone_number }}</span>
                </p>
              </td>
            </tr>
          </table>

          <table
            style="width: 100%"
            id="print-table3"
          >
            <tr style="height: 120px">
              <td id="price-section00">
                <p style="font-size: 14px; font-weight: bold">{{ $t('columns.description') }}</p>
                <p
                  v-if="detailData.note != null"
                  style="font-size: 14px; font-weight: bold"
                >
                  {{ $t('columns.note') }}
                </p>
                <p
                  v-if="detailData.old_price != null"
                  style="font-size: 14px; font-weight: bold"
                >
                  {{ $t('logs.oldAmount') }}
                </p>
                <p
                  v-if="detailData.old_price != null"
                  style="font-size: 14px; font-weight: bold"
                >
                  {{ $t('logs.newAmount') }}
                </p>
                <p
                  v-else
                  style="font-size: 14px; font-weight: bold"
                >{{ $t('columns.amount') }}</p>
              </td>
              <td id="price-section11">
                <p style="font-size: 14px; font-weight: normal">: {{ detailData.description }}</p>
                <p
                  v-if="detailData.note != null"
                  style="font-size: 14px; font-weight: normal"
                >
                  : {{ detailData.note }}
                </p>
                <p
                  v-if="detailData.old_price != null"
                  style="font-size: 14px; font-weight: normal"
                >
                  : ${{ detailData.old_price }}
                </p>
                <p style="font-size: 14px; font-weight: normal">: ${{ detailData.amount }}</p>
              </td>
            </tr>
          </table>

          <table style="width: 100%">
            <tr>
              <td style="text-align: right; border: 1px solid #000" class="print-pr-10">
                <p style="font-size: 14px; font-weight: bold">
                  {{ $t('columns.total') }}:
                  <span style="font-weight: normal"><b>${{ detailData.amount }}</b></span>
                </p>
                <p style="font-size: 14px; font-weight: bold">
                  {{ $t('columns.exRate') }}:
                  <span style="font-weight: normal"><b>{{ effectiveExRate }}</b></span>
                </p>
                <p style="font-size: 14px; font-weight: bold">
                  {{ $t('logs.totalIqdLabel') }}:
                  <span style="font-weight: normal"><b>{{ totalIqd }} IQD</b></span>
                </p>
              </td>
            </tr>
          </table>

          <div class="print-float-right">
            <v-btn
              @click="printInvoice"
              id="print-button"
              style="height:auto"
              outline
              color="primary"
            >{{ $t('printLogs.printButton') }}</v-btn>
          </div>
        </div>

        <!-- PRINTABLE TABLEs -->
        <table
          id="head-table"
          style="padding-top: 30px; width: 100%"
          class="show-in-print"
        >
          <tr>
            <td class="print-pl-20">
              <img
                style="width: 110px; height: 100px"
                id="header-img"
                src="../../../assets/images/black_shipzone.png"
                alt=""
              />
            </td>
            <td>
              <table
                id="company-info"
                style="width: 100%;" class="print-ml-0"
              >
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-10">
                    {{ companyData.company_name }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-10">
                    {{ companyData.company_address }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-10">
                    {{ companyData.company_email }}
                  </td>
                </tr>
                <tr class="header-table">
                  <td style="font-size: 14px" class="print-pr-10">
                    {{ companyData.phone_number }}
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>

        <div class="modal-body show-in-print">
          <table
            style="width: 100%"
            id="print-table1"
          >
            <tr>
              <td id="credit-table-header">
                <strong style="font-size: 20px">
                  <span v-if="detailData.action === 'cash back'">{{ $t('logs.cashBackInvoiceTitle') }}</span>
                  <span v-else>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ $t('logs.receiptLabel') }}
                  </span>
                </strong>
              </td>
            </tr>
          </table>

          <table
            style="width: 100%"
            id="print-table2"
          >
            <tr>
              <td id="info-section1">
                <!-- <p style="font-size: 14px; font-weight: bold; margin: 8px 0px;">
                  Branch:
                  <span style="font-weight: normal">{{ detailData.branch_name }}</span>
                </p> -->
                <p style="font-size: 14px; font-weight: bold; margin: 8px 0px;">
                  {{ $t('columns.invoiceNumber') }}:
                  <span style="font-weight: normal">{{ detailData.invoice_number }}</span>
                </p>
                <p
                  v-if="detailData.base_invoice_number != null"
                  style="font-size: 14px; font-weight: bold; margin: 8px 0px"
                >
                  {{ $t('logs.creditInvoiceNumber') }}:
                  <span style="font-weight: normal">{{ detailData.base_invoice_number }}</span>
                </p>
                <p
                  v-if="detailData.credit_log_action_date != null"
                  style="font-size: 14px; font-weight: bold; margin: 8px 0px"
                >
                  {{ $t('customer.invoiceDate') }}:
                  <span style="font-weight: normal">{{ detailData.credit_log_action_date }}</span>
                </p>
                <p
                  v-else
                  style="font-size: 14px; font-weight: bold; margin: 8px 0px"
                >
                  {{ $t('customer.invoiceDate') }}:
                  <span style="font-weight: normal">{{ detailData.created_at }}</span>
                </p>
              </td>
              <td id="info-section2">
                <p style="font-size: 14px; font-weight: bold; margin: 8px 0px">
                  {{ $t('columns.customerName') }}:
                  <span style="font-weight: normal">{{ detailData.customer_name }}</span>
                </p>
                <p style="font-size: 14px; font-weight: bold; margin: 8px 0px">
                  {{ $t('logs.customerAddress') }}:
                  <span style="font-weight: normal">{{ detailData.customer_address }}</span>
                </p>
                <p style="font-size: 14px; font-weight: bold; margin: 8px 0px">
                  {{ $t('logs.customerTel') }}:
                  <span style="font-weight: normal">{{ detailData.phone_number }}</span>
                </p>
              </td>
            </tr>
          </table>

          <table
            style="width: 100%"
            id="print-table3"
          >
            <tr style="height: 120px">
              <td id="price-section00">
                <p style="font-size: 14px; font-weight: bold">{{ $t('columns.description') }}</p>
                <p
                  v-if="detailData.note != null"
                  style="font-size: 14px; font-weight: bold"
                >
                  {{ $t('columns.note') }}
                </p>
                <p
                  v-if="detailData.old_price != null"
                  style="font-size: 14px; font-weight: bold"
                >
                  {{ $t('logs.oldAmount') }}
                </p>
                <p
                  v-if="detailData.old_price != null"
                  style="font-size: 14px; font-weight: bold"
                >
                  {{ $t('logs.newAmount') }}
                </p>
                <p
                  v-else
                  style="font-size: 14px; font-weight: bold"
                >{{ $t('columns.amount') }}</p>
              </td>
              <td id="price-section11">
                <p style="font-size: 14px; font-weight: normal">: {{ detailData.description }}</p>
                <p
                  v-if="detailData.note != null"
                  style="font-size: 14px; font-weight: normal"
                >
                  : {{ detailData.note }}
                </p>
                <p
                  v-if="detailData.old_price != null"
                  style="font-size: 14px; font-weight: normal"
                >
                  : ${{ detailData.old_price }}
                </p>
                <p style="font-size: 14px; font-weight: normal">: ${{ detailData.amount }}</p>
              </td>
            </tr>
          </table>

          <table style="width: 100%">
            <tr>
              <td style="text-align: right; border: 1px solid #000" class="print-pr-10">
                <p style="font-size: 14px; font-weight: bold">
                  {{ $t('columns.total') }}:
                  <span style="font-weight: normal"><b>${{ detailData.amount }}</b></span>
                </p>
                <p style="font-size: 14px; font-weight: bold">
                  {{ $t('columns.exRate') }}:
                  <span style="font-weight: normal"><b>{{ effectiveExRate }}</b></span>
                </p>
                <p style="font-size: 14px; font-weight: bold">
                  {{ $t('logs.totalIqdLabel') }}:
                  <span style="font-weight: normal"><b>{{ totalIqd }} IQD</b></span>
                </p>
              </td>
            </tr>
          </table>
        </div>

        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['detailData', 'closeModal', 'companyData', 'exRate'],

  computed: {
    // The rate actually in effect when this money was recorded (CreditLogActionController::
    // show() selects credit_log_actions.ex_rate) - not today's rate, since a rate change
    // between then and now would otherwise misstate what was actually paid/received in IQD at
    // the time. Only legacy rows that predate the ex_rate column (and haven't been backfilled
    // via credit_log_actions:backfill-ex-rate) fall back to the live current rate (the exRate
    // prop, fetched fresh whenever this modal opens - see creditLogAction.vue's initDetail()).
    hasHistoricalExRate() {
      return Number(this.detailData.ex_rate) > 0
    },
    effectiveExRate() {
      return this.hasHistoricalExRate ? Number(this.detailData.ex_rate) : (Number(this.exRate) || 1)
    },
    totalIqd() {
      return Math.round((Number(this.detailData.amount) || 0) * this.effectiveExRate).toLocaleString('en-US')
    }
  },

  mounted() {
    let theModal = document.querySelector('.modal')
    theModal.style.overflowX = 'auto'
    $('.show-in-print').hide()
  },

  methods: {
    printInvoice() {
      $('#close-button').hide()
      $('#print-button').hide()
      $('.show-in-print').show()

      $('#print-area').printMe({ path: this.$_print_stylesheet_paths() })

      $('#close-button').show()
      $('#print-button').show()
      $('.show-in-print').hide()
    }
  }
}
</script>

<style>
#print-area {
  max-width: 850px;
}

.modal {
  text-align: center;
  padding: 0 !important;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

@media screen and (max-width: 650px) {
  #credit-table-header {
    width: 500px;
    padding-left: 10px;
  }
  #price-section2 {
    width: 500px;
    padding-left: 10px;
    padding-top: 10px;
    font-size: 15px;
  }
  #price-section {
    width: 280px;
  }
  #company-info {
    width: 100%;
  }
  #header-img {
    width: 60px;
    height: 60px;
  }
  #print-area {
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/logs/viewActionLog.vue